<template>
    <section class="">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
                     :btn_add="false"
                     :btn_delete="false"
                     btn_review
                     @review="handleMeetingReview"
        >
        </front-table>
        <!--编辑界面-->
        <el-dialog class="front-dialog" :visible.sync="show_edit"
                   :close-on-click-modal="false" width="75%">
            <h5 slot="title" v-if="single.book">调查: {{single.book.meeting_date}} {{single.book.meeting_time}}
                {{single.book.duration}} {{single.book.topic}}
            </h5>
            <el-form :model="single" ref="editForm" label-position="top">
                <el-form-item :label="'('+(1+index)+') '+item.question"
                              v-for="(item,index) in single.survey" :key="item.id">
                    <el-input v-if="item.type==3"
                              v-model="single.answers[item.id]"
                              :disabled="single.readonly"
                              type='text'
                              size='small'>
                    </el-input>
                    <el-radio-group v-if="item.type==2"
                                    v-model="single.answers[item.id]"
                                    :disabled="single.readonly"
                                    size='small'>
                        <el-radio v-for="(x,index) in item.options" :label="x" :key="index"></el-radio>
                    </el-radio-group>
                    <el-rate v-if="item.type==1"
                             v-model="single.answers[item.id]"
                             :disabled="single.readonly"
                             size='small'>
                    </el-rate>
                </el-form-item>
            </el-form>
            <div slot="footer" class="">
                <slot name="footer"></slot>
                <el-button @click="show_edit=false" size="small">{{'放弃'}}</el-button>
                <el-button :disabled="single.readonly" type="primary" @click="handleEditSubmit" size="small">{{('提交')}}
                </el-button>
            </div>
        </el-dialog>

        <meeting-view :view_mode="view_mode" :single="meeting" @cancel="view_mode = false">
        </meeting-view>

        <div class="clearfix"></div>
    </section>
</template>

<script>
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";
    import MeetingView from "../components/meeting-view";

    export default {
        mixins: [FrontMixins],
        name: 'questionnaire',
        components: {FrontTable,MeetingView},
        created() {
            this.model = 'Questionnaire';
        },
        data() {
            return {
                show_edit: false,
                meeting:{}
            }
        },
        methods: {
            handleEdit(id) {
                if (id !== 0) {
                    this.$api(this.model + '.Get', {id: id}, true).then(res => {
                        const single = {book: {}, survey: {}, answers:[],readonly:false};
                        this.$set(this, 'single', Object.assign({}, single, res.data.data));
                        this.single.survey.forEach((item)=>{
                           if (item.type === '1') {
                               if (this.single.answers[item.id]) {
                                   this.single.answers[item.id] = parseInt(this.single.answers[item.id]);
                               }
                           }
                        });
                        this.show_edit = true;
                    });
                }
            },
            handleEditSubmit() {
                let vm = this;
                this.$api(this.model + '.Edit', {id:this.single.book.id,answers:this.single.answers}, true).then(() => {
                        vm.edit = false;
                        vm.$notice.success('问卷更新成功!');
                        vm.show_edit = false;
                        vm.reload();
                    }
                );
            },
            handleMeetingReview(id){
                let vm = this;
                this.$api('Meeting' + '.Get', {id: id, review: true}, true).then(res => {
                    vm.meeting = res.data.data;
                    this.view_mode = true;
                });
            }
        }
    }
</script>

<style lang="scss">


</style>
